// Raqam, pul va sana formatlari — brendbuk: "1 250 000 soʻm", "16.10.2026", "14:30".

const NBSP = String.fromCharCode(160);

/** @param {number|string|null|undefined} n */
export function fmtNumber(n, digits = 0) {
  if (n === null || n === undefined || n === "") return "—";
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  const [int, frac] = Math.abs(v).toFixed(digits).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  return (v < 0 ? "−" : "") + grouped + (frac ? "," + frac : "");
}

/** Pul: kasr faqat bo'lsa ko'rsatiladi. */
export function fmtMoney(n, currency = "UZS") {
  if (n === null || n === undefined) return "—";
  const v = Number(n);
  const digits = Number.isInteger(v) ? 0 : 2;
  if (currency === "USD") return (v < 0 ? "−$" : "$") + fmtNumber(Math.abs(v), digits);
  return `${fmtNumber(v, digits)}${NBSP}soʻm`;
}

/** @param {string|Date|null|undefined} d */
export function fmtDate(d) {
  if (!d) return "—";
  const x = typeof d === "string" && d.length === 10 ? new Date(d + "T00:00:00") : new Date(d);
  if (Number.isNaN(x.getTime())) return "—";
  const p = (/** @type {number} */ v) => String(v).padStart(2, "0");
  return `${p(x.getDate())}.${p(x.getMonth() + 1)}.${x.getFullYear()}`;
}

export function fmtDateTime(d) {
  if (!d) return "—";
  const x = new Date(d);
  const p = (/** @type {number} */ v) => String(v).padStart(2, "0");
  return `${fmtDate(x)} ${p(x.getHours())}:${p(x.getMinutes())}`;
}

export function todayISO() {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export function addDaysISO(iso, days) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + days);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export function monthISO(d = new Date()) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/** "24 000" yoki "24000" → 24000 (oddiy va bo'linmas bo'shliqlar olib tashlanadi) */
export function parseAmount(s) {
  if (typeof s === "number") return s;
  const v = String(s ?? "")
    .replace(/\s/g, "")
    .replace(",", ".");
  return v === "" ? NaN : Number(v);
}

export function initials(name = "") {
  return (
    name
      .split(/\s+/)
      .map((w) => w.replace(/^[^\p{L}\p{N}]+/u, ""))
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0])
      .join("")
      .toUpperCase() || "?"
  );
}
